export const COLUMNS = {
  ["Transaction ID"]: "Transaction ID",
  CardNumber: "CardNumber",
  ["Date/Time"]: "Date/Time",
  ["Transaction Status"]: "Transaction Status",
  Refund: "Refund",
};
